import { Box, Pagination } from "@mui/material"
import React, { useCallback, useMemo, useState } from "react"
// eslint-disable-next-line camelcase
import { PatchNote3_1 } from "./PatchNote3_1"
import { PatchNote3_2 } from "./PatchNote3_2"
import { PatchNote3_3 } from "./PatchNote3_3"

export function PatchNotesList(): React.JSX.Element {
  const [page, setPage] = useState<number>(1)

  const patchNotes = useMemo(
    () => [<PatchNote3_3 key="patch3_2" />, <PatchNote3_2 key="patch3_2" />, <PatchNote3_1 key="patch3_1" />],
    []
  )

  const handleChange = useCallback((event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value)
  }, [])

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {patchNotes[page - 1]}
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <Pagination count={patchNotes.length} page={page} onChange={handleChange} />
      </Box>
    </Box>
  )
}
